export default __webpack_public_path__ + "static/media/situation_nav_icon.c611ab50.svg";